import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AIPlugin } from '../../aiPluginType';

/**
 * Get the content ID from the AI experience plugin,
 * falling back to the current page URL (without query params and hash).
 *
 * Should always can this method to get the content ID,
 * instead of storing it somewhere else,
 * because the targetId is updated asynchronously.
 *
 * @param api - The editor plugin API
 * @returns The content object ID, or the base URL as a fallback
 */
export function getContentId(api: ExtractInjectionAPI<AIPlugin> | undefined): string {
	const targetId =
		api?.aiExperience?.sharedState.currentState()?.aiDecorationExperiencePluginState.targetId;
	return targetId ? String(targetId) : window.location.origin + window.location.pathname;
}
